// removed by extract-text-webpack-plugin
module.exports = {"map-icon":"map-icon__MJvEE","cluster":"cluster__3szSk","pin":"pin__3iSUu","current-location":"current-location__2zjLY","label":"label__2GnpJ","charger":"charger__3H1tS","place":"place__2xpTt","bubble":"bubble__1wYTD"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/MapMarker/styles.scss
// module id = ./app/scripts/views/App/components/MapMarker/styles.scss
// module chunks = 1